import React from "react";

const DataAssetsOverview: React.FC = () => {
  return <div style={{padding: "1em"}}>Data Assets Overview</div>;
};

export default DataAssetsOverview;
